/* =============================================================
   objectModal.js
   Classe per la modale generica #objectModal (Controls/Modals/MDLObject.ascx).
   Due modalita':
     - 'view'   : anteprima sola lettura (bottone Salva nascosto)
     - 'insert' : form di inserimento (bottone Salva visibile + callback onSave)
   Si auto-registra su application.ModalManagerIstance quando l'app e' pronta,
   sullo stesso pattern di eventModal (calendarManager.js) -> NON tocca app.js ne' i bundle.
   FV - 2026-06-10 - creazione (modale unificata anteprima/inserimento)
   ============================================================= */
class ObjectModal {

    Id = null;
    _element = null;

    constructor(selector) {
        this.Id = selector;
        this._element = document.getElementById(selector);
    }

    /**
     * Apre la modale.
     * @param {Object} o
     * @param {string} o.title                 Titolo header (HTML ammesso)
     * @param {string|HTMLElement} o.content    HTML o nodo da iniettare nel body
     * @param {('view'|'insert')} [o.mode='view']
     * @param {function} [o.onSave]             Callback bottone Salva (riceve l'istanza); solo 'insert'
     * @param {string} [o.saveText='Salva']
     * @param {string} [o.closeText='Chiudi']
     * @param {{text:string,type:string}} [o.badge]  Badge opzionale (type: success|warning|danger|secondary...)
     */
    open(o) {
        o = o || {};
        try {
            const mode = o.mode || 'view';

            // --- Titolo ---
            this._element.querySelector('#objectModalLabel').innerHTML = o.title || '';

            // --- Reset errore ---
            const err = this._element.querySelector('#objectModalError');
            err.classList.add('d-none');
            err.innerHTML = '';

            // --- Contenuto ---
            const body = this._element.querySelector('#objectModalBody');
            body.innerHTML = '';
            if (o.content instanceof HTMLElement) {
                body.appendChild(o.content);
            } else {
                body.innerHTML = o.content || '';
            }

            // --- Badge (opzionale) ---
            const badge = this._element.querySelector('#objectModalBadge');
            badge.className = 'badge d-none ms-2';
            if (o.badge && o.badge.text) {
                badge.textContent = o.badge.text;
                badge.classList.add('text-bg-' + (o.badge.type || 'secondary'));
                badge.classList.remove('d-none');
            }

            // --- Footer ---
            const cancelBtn = this._element.querySelector('#objectModalCancel');
            cancelBtn.textContent = o.closeText || 'Chiudi';

            // Clono il bottone Salva per azzerare eventuali listener della chiamata precedente
            let saveBtn = this._element.querySelector('#objectModalSave');
            const freshSave = saveBtn.cloneNode(true);
            saveBtn.parentNode.replaceChild(freshSave, saveBtn);

            if (mode === 'insert') {
                freshSave.textContent = o.saveText || 'Salva';
                freshSave.classList.remove('d-none');
                if (typeof o.onSave === 'function') {
                    freshSave.addEventListener('click', () => o.onSave(this));
                }
            } else {
                freshSave.classList.add('d-none');
            }

            application.ModalManagerIstance.show(this.Id);
        } catch (e) {
            console.error('[objectModal] open', e);
        }
    }

    /** Mostra un messaggio di errore nel body (utile in modalita' insert). */
    showError(msg) {
        const err = this._element.querySelector('#objectModalError');
        err.innerHTML = msg;
        err.classList.remove('d-none');
    }

    close() {
        application.ModalManagerIstance.hide(this.Id);
    }
}

/* Helper globale comodo per l'anteprima sola lettura (stile Modal_ShowWait).
   Esempio: ObjectModal_ShowPreview('Elenco contatti', document.getElementById('boxProfileContacts').innerHTML); */
function ObjectModal_ShowPreview(title, htmlContent) {
    if (window.application && application.ObjectModalIstance) {
        application.ObjectModalIstance.open({ title: title, content: htmlContent, mode: 'view' });
    } else {
        console.warn('[objectModal] application.ObjectModalIstance non ancora pronta');
    }
}

/* Auto-registrazione: stessa logica di eventModal, senza toccare app.js.
   Aspetta che l'app (global "application" + ModalManagerIstance) sia disponibile. */
(function () {
    function initObjectModal() {
        if (typeof application === 'undefined' || !application || !application.ModalManagerIstance) return false;
        if (!document.getElementById('objectModal')) return false;
        if (application.ObjectModalIstance) return true; // gia' registrata
        application.ObjectModalIstance = new ObjectModal('objectModal');
        application.ModalManagerIstance.register('objectModal', null, null);
        return true;
    }
    document.addEventListener('appBuilt', initObjectModal);
    document.addEventListener('DOMContentLoaded', function () {
        if (!initObjectModal()) { setTimeout(initObjectModal, 600); }
    });
})();
